 
 
 
 
 
 
define([
    'model/objectModel',
    '../../services/utils'
], function(
    ObjectModel,
    utils
) {
    'use strict';

    var AddressRangesModel = function(json) {
        this.from = utils.convertToLatLng(json.from);
        this.to = utils.convertToLatLng(json.to);

        this.rangeLeftStart = json.rangeLeft.match(/\w+/g)[0];
        this.rangeLeftEnd = json.rangeLeft.match(/\w+/g)[1];

        this.rangeRightStart = json.rangeRight.match(/\w+/g)[0];
        this.rangeRightEnd = json.rangeRight.match(/\w+/g)[1];

        return this;
    };

    AddressRangesModel.prototype = Object.create(ObjectModel.prototype);
    AddressRangesModel.prototype.constructor = AddressRangesModel;

    AddressRangesModel.prototype.simplify = function() {
        return {
            from: {lat: this.from.lat, lon: this.from.lng},
            to: {lat: this.to.lat, lon: this.to.lng},
            rangeLeft: this.rangeLeftStart + ' - ' + this.rangeLeftEnd,
            rangeRight: this.rangeRightStart + ' - ' + this.rangeRightEnd
        };
    };

    return AddressRangesModel;
});



// WEBPACK FOOTER //
// ./model/search/addressRangesModel.js